import { getApiCall } from '../utils/Api';

export const countriesList = async (searchText) => {
  const result = await getApiCall(`/filmmakers/countries/search?searchText=${searchText}`);
  return result.data;
};

export const videosList = async (searchText) => {
  const result = await getApiCall(`/filmmakers/films/search?searchText=${searchText}`);
  return result.data;
};
